import axiosInstance from '../helpers/axios';
import { handleError, handleSuccess, waitAndReload } from '../helpers/utils';
import { types } from '../types/types';
import { getToken } from './auth';

// Dispatch set user obj
export const setUser = (data) => ({
	type: types.setUser,
	payload: data,
});

// Dispatch clean user obj
export const cleanUser = () => ({
	type: types.cleanUser,
});

// Get all usersX
export const getUsers = async () => {
	const token = getToken();
	return await axiosInstance({
		method: 'get',
		url: '/api/auth/users?is_deleted=0&is_client=0&page_size=200',
		headers: { Authorization: 'Bearer ' + token },
	});
};

// Get all users from an specific division
export const getUsersFromDivision = async (divisionCode) => {
	const token = getToken();
	return await axiosInstance({
		method: 'get',
		url: `/api/auth/users?page_size=100&division=${divisionCode}`,
		headers: { Authorization: 'Bearer ' + token },
	});
};

// Start login with email & password
export const registerUser = (userInfo) => {
	return () => {
		// Get token if authenticated
		const token = getToken();
		axiosInstance({
			method: 'post',
			url: '/api/auth/register',
			data: userInfo,
			headers: { Authorization: 'Bearer ' + token },
		})
			.then(({ data }) => {
				// console.log(data);
				handleSuccess('El usuario se creó correctamente');
				// waitAndReload();
			})
			.catch((error) => {
				handleError(error, 'No se pudo registrar el usuario.');
			});
	};
};

// Update user
export const updateUser = (user, data) => {
	return () => {
		// Get token if authenticated
		const token = getToken();
		axiosInstance({
			method: 'put',
			url: `/api/auth/update/${user.id}`,
			headers: { Authorization: 'Bearer ' + token },
			data: { ...user, ...data },
		})
			.then(() => {
				handleSuccess('Usuario actualizado correctamente.');
			})
			.catch((error) => {
				handleError(error, 'No se pudo eliminar al usuario.');
			});
	};
};

// Update user
export const updateUserPhoto = async (user, img_profile) => {
	const token = getToken();
	return await axiosInstance({
		method: 'put',
		url: `/api/auth/update/${user.id}`,
		headers: { Authorization: 'Bearer ' + token },
		data: {
			...user,
			area: user?.area?.id || null,
			user_type: user?.user_type?.id,
			img_profile: img_profile,
		},
	});
};

// Delete user
export const deleteUser = (id) => {
	return () => {
		// Get token if authenticated
		const token = getToken();
		axiosInstance({
			method: 'delete',
			url: `/api/auth/user/${id}`,
			headers: { Authorization: 'Bearer ' + token },
		})
			.then(() => {
				handleSuccess('Usuario eliminado correctamente.');
				waitAndReload();
			})
			.catch((error) => {
				handleError(error, 'No se pudo eliminar al usuario.');
			});
	};
};

// User info of an specific user
export const getUserInfo = async (id) => {
	const token = getToken();
	return await axiosInstance({
		method: 'get',
		url: `/api/auth/user/${id}`,
		headers: { Authorization: 'Bearer ' + token },
	});
};

// Get all the staff and admin contacts
export const getAllStaffAndAdminContacts = async () => {
	const token = getToken();
	return await axiosInstance({
		method: 'get',
		url: '/api/auth/staff-admin-contacts',
		headers: { Authorization: 'Bearer ' + token },
	});
};
